export const INDEX_PAGE = '/index.html';

export const abandonedCartUTM =
  '?utm_source=papajohns&utm_medium=push_notifications&utm_campaign=abandoned_cart';
